var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solution-section"},[_c('h2',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('solution.sectionTitle')))]),_c('p',{staticClass:"section-subtitle"},[_vm._v(_vm._s(_vm.$t('solution.sectionSubtitle')))]),_c('img',{attrs:{"alt":_vm.$t('solution.backgroundImageAlt'),"src":require("../assets/solution-background.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }